import { render, staticRenderFns } from "./knowledgeTable.vue?vue&type=template&id=94c16670&scoped=true"
import script from "./knowledgeTable.vue?vue&type=script&lang=js"
export * from "./knowledgeTable.vue?vue&type=script&lang=js"
import style0 from "./knowledgeTable.vue?vue&type=style&index=0&id=94c16670&prod&lang=less"
import style1 from "./knowledgeTable.vue?vue&type=style&index=1&id=94c16670&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c16670",
  null
  
)

export default component.exports